module.exports = __webpack_public_path__ + "static/p2p-finance-paper-79eabacd9ba0ede02d85683a3c1bb061.png";